<template>
  <div>
    <section>
      <div class="sf-pricing-head">
        <h1 class="sf-pricing-title">
          {{ $t('ativacao.videotitle') }}
        </h1>
        <p class="sf-pricing-subtitle">
          {{ $t('ativacao.videoText') }}
        </p>
      </div>
      <b-embed
        type="iframe"
        src="https://www.youtube.com/embed/yQ_ezV-Ymlw?rel=0"
        allowfullscreen
      />
    </section>

    <section
      v-if="Object.keys(data).length"
      id="pricing-plan"
      class="mt-4"
    >
      <div class="sf-pricing-head">
        <h1 class="sf-pricing-title">
          {{ $t('ativacao.title') }}
        </h1>
        <p class="sf-pricing-subtitle">
          {{ $t('ativacao.text') }}
        </p>
      </div>

      <div
        v-for="plano in data"
        :key="plano.id"
        class="sf-pricing-grid mb-3"
      >
        <div
          v-for="planoVar in plano.planoVariacao"
          :key="planoVar.id"
          class="sf-pricing-card"
          :class="{ popular: planoVar.popular }"
        >
          <span
            v-if="planoVar.popular"
            class="sf-pricing-popular-badge"
          >{{ $t('ativacao.badgeText') }}</span>

          <b-img
            :src="require('@/assets/images/illustration/badge.svg')"
            class="sf-pricing-icon"
            alt="basic svg img"
          />

          <div class="sf-pricing-name">
            {{ plano.nome }}
            <b-badge variant="warning">
              {{ planoVar.nome }}
            </b-badge>
          </div>

          <div class="sf-pricing-price-row">
            <span class="sf-pricing-currency">$</span>
            <span class="sf-pricing-value">{{ planoVar.precoFinal }}</span>
          </div>
          <div class="sf-pricing-duration">
            (
            <template v-if="planoVar.preco == 0">
              {{ $t('ativacao.licencia') }} {{ $t('ativacao.gratis') }}
            </template>
            <template v-else>
              {{ planoVar.preco }} {{ $t('ativacao.licencia') }}
            </template>
            <template v-if="planoVar.creditoTaxaDesempenho > 0">
              + {{ planoVar.creditoTaxaDesempenho }} {{ $t('ativacao.creditoTaxaDesempenho') }}
            </template>
            )
          </div>

          <ul class="sf-pricing-benefits">
            <li
              v-for="(item, index) in planoVar.beneficio"
              :key="index"
            >
              <feather-icon icon="CheckIcon" />
              <span>{{ item }}</span>
            </li>
          </ul>

          <b-link
            v-ripple.400="'rgba(59, 130, 246, 0.15)'"
            class="sf-pricing-btn"
            :to="{ name: 'checkout', params: { nomePlano: plano.nomeUrl, nomePlanoVariacao: planoVar.nomeUrl } }"
          >
            {{ $t('ativacao.compraBtn') }}
          </b-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  BImg, BBadge, BEmbed, BLink,
} from 'bootstrap-vue'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import ativacaoStoreModule from './ativacaoStoreModule'

const ATIVACAO_STORE_MODULE_NAME = 'ativacao'

/* eslint-disable global-require */
export default {
  components: {
    BBadge,
    BImg,
    BEmbed,
    BLink,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {},
    }
  },

  created() {
    if (!store.hasModule(ATIVACAO_STORE_MODULE_NAME)) store.registerModule(ATIVACAO_STORE_MODULE_NAME, ativacaoStoreModule)
    this.fetch()
  },

  beforeDestroy() {
    if (store.hasModule(ATIVACAO_STORE_MODULE_NAME)) store.unregisterModule(ATIVACAO_STORE_MODULE_NAME)
  },

  methods: {
    fetch() {
      store
        .dispatch('ativacao/getPlanos')
        .then(response => {
          this.data = response.data
        })
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss" scoped>
/* ============================================================
   Pricing cards — padrão Soulf (planos/upgrade/recarga).
   ============================================================ */
.sf-pricing-head { text-align: center; margin: 24px 0 28px; }
.sf-pricing-title { font-size: 22px; font-weight: 600; color: #fff; margin: 0 0 6px; }
.sf-pricing-subtitle { font-size: 13.5px; color: rgba(255, 255, 255, 0.55); margin: 0; }

.sf-pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 20px;
}

.sf-pricing-card {
  position: relative;
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 16px;
  padding: 28px 22px;
  text-align: center;
  display: flex;
  flex-direction: column;

  &.popular { border-color: rgba(59, 130, 246, 0.40); }
}
.sf-pricing-popular-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  font-family: 'Geist', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.12);
  border-radius: 9999px;
  padding: 3px 10px;
}
.sf-pricing-icon { width: 52px; height: 52px; margin: 0 auto 14px; opacity: 0.9; }
.sf-pricing-name {
  font-family: 'Geist', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.sf-pricing-price-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin: 18px 0 4px;
}
.sf-pricing-currency {
  font-family: 'Geist Mono', 'SFMono-Regular', Menlo, monospace;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
}
.sf-pricing-value {
  font-family: 'Geist Mono', 'SFMono-Regular', Menlo, monospace;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.02em;
}
.sf-pricing-duration {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 18px;
}
.sf-pricing-benefits {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 9px;
  flex: 1;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.70);
    line-height: 1.4;

    .feather {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      margin-top: 2px;
      color: #4ade80;
    }
  }
}
.sf-pricing-btn {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: none;
  background: #3b82f6;
  color: #fff !important;
  font-family: 'Geist', sans-serif;
  font-weight: 600;
  font-size: 13px;
  padding: 11px 0;
  border-radius: 9999px;
  cursor: pointer;
  text-decoration: none;
  transition: transform .15s ease, opacity .15s ease;

  &:hover { transform: translateY(-2px); color: #fff !important; text-decoration: none; }
  &.sf-pricing-btn-outline {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: rgba(255, 255, 255, 0.70) !important;
  }
  &.disabled, &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none !important;
    pointer-events: none;
  }
}
</style>
